import axios from 'axios';
import { User } from '../../types/User';

const prodBaseUrl = 'https://europe-west2-prod-evc-app.cloudfunctions.net/evc_base';
const devBaseUrl = 'https://europe-west2-dev-evc-app-4d345.cloudfunctions.net/evc_base';
const baseUrl = process.env.REACT_APP_ENV !== 'prod' ? devBaseUrl : prodBaseUrl;

export abstract class BaseRepository {
  static async sendStatementAppeal(
    emailFrom: string,
    emailMsg: string,
    statementRef: string,
    token: string,
  ) {
    try {
      const response = await axios.post(
        `${baseUrl}/statements/appeal`,
        {
          emailFrom,
          emailMsg,
          statementRef,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async sendInvoice(file: File, user: User, statementRef: string) {
    const { firstName, lastName, email, token } = user;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('firstName', String(firstName));
    formData.append('lastName', String(lastName));
    formData.append('email', String(email));
    formData.append('statementReference', String(statementRef));

    const res = await axios.post(`${baseUrl}/statements/sendInvoice`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'content-type': 'multipart/form-data',
      },
    });

    return res.data;
  }
}
